// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-tabs[data-v-7edaeb71] {\n  margin-bottom: 16px;\n}\n.v-row[data-v-7edaeb71] {\n  margin-bottom: 24px;\n}\n.v-col h3[data-v-7edaeb71],\n.v-col h4[data-v-7edaeb71] {\n  margin-bottom: 16px;\n  color: #1976d2;\n}\n", ""]);
// Exports
module.exports = exports;
